import { createFileRoute } from "@tanstack/react-router";
import { cityServiceHead } from "../lib/route-head";
import { CityServicePage } from "../components/city-service-page";
import { getCityService } from "../data/city-services";

export const Route = createFileRoute("/commercial-pressure-washing-schenectady-ny")({
  loader: async () => {
    const c = (await import("../data/city-services")).getCityService("commercial-pressure-washing-schenectady-ny")!;
    return { meta: c.meta, heroImage: c.heroImage, service: c.service, city: c.city, faqs: c.faqs };
  },
  head: ({ loaderData }) => cityServiceHead("commercial-pressure-washing-schenectady-ny", "commercial-pressure-washing", loaderData),
  component: RouteComponent,
});

function RouteComponent() {
  return <CityServicePage content={getCityService("commercial-pressure-washing-schenectady-ny")!} />;
}
